import React, { useState } from 'react';
import { Crown } from 'lucide-react';

/**
 * Logo component.
 * To customize: replace `/app/frontend/public/logo.png` (or logo.svg) with your file.
 * If missing, falls back to the Crown icon. No code changes needed.
 */
export default function Logo({ size = 40, className = '' }) {
  const [failed, setFailed] = useState(false);
  if (failed) {
    return (
      <div
        className={`flex items-center justify-center rounded-2xl bg-[var(--gold-soft)] border border-[var(--gold)]/30 ${className}`}
        style={{ width: size, height: size }}
      >
        <Crown className="text-[var(--gold)]" style={{ width: size * 0.55, height: size * 0.55 }} strokeWidth={1.5} />
      </div>
    );
  }
  return (
    <img
      src="/logo.png"
      alt="Golden TV Connect"
      onError={() => setFailed(true)}
      className={`rounded-2xl object-cover ${className}`}
      style={{ width: size, height: size }}
      data-testid="app-logo"
    />
  );
}
